import { Image } from "react-bootstrap";
import cx from "classnames";

import styles from "./styles.module.scss";
const DefaultProfilePicture = "/images/default_user_profile_background.png";

interface UserIconProps {
  isOnline: boolean;
  imageSrc: string;
}

const UserIcon: React.FC<UserIconProps> = ({ isOnline, imageSrc }) => {
  return (
    <div className={cx(styles.container, {
      [styles.active]: isOnline,
    })}>
      <Image src={imageSrc || DefaultProfilePicture} className={styles.profilePicture} />
    </div>
  )
}

export default UserIcon;